import scrollIt from './scroll-it';

export default function anchorLinks() {
    const linksEls = document.querySelectorAll('.js--anchor');
    linksEls.forEach((link) => {
        link.addEventListener('click', (e) => {
            e.preventDefault();
            const { href } = link;
            const anchorValue = new URL(href).hash.slice(1);
            const anchoredEl = document.getElementById(anchorValue);
            if (anchoredEl) scrollIt(anchoredEl, 500);
        });
    });
}
